import {
  GO_TO_FORM,
  NAVIGATE_TO_INDEX,
  SET_REMINDERS,
  SET_LOADING,
  SET_DESTROYING,
  GO_TO_DESTROY,
  GO_TO_ERROR,
  REMINDER_CREATED,
  REMINDER_UPDATED,
  REMINDER_DELETED,
  UPDATE_PROPS
} from './actions'

export const VIEWS = {
  INDEX: 'index',
  FORM: 'form',
  DESTROY: 'destroy',
  ERROR: 'error'
}

export default function reducer (state, { type, payload }) {
  switch (type) {
    case UPDATE_PROPS:
      return {
        ...state,
        ...propsToState(payload.props)
      }
    case NAVIGATE_TO_INDEX:
      return {
        ...state,
        view: VIEWS.INDEX,
        cameFrom: state.view
      }
    case SET_REMINDERS:
      return {
        ...state,
        reminders: payload.reminders
      }
    case SET_LOADING:
      return {
        ...state,
        isLoading: payload.isLoading
      }
    case SET_DESTROYING:
      return {
        ...state,
        isDestroying: payload.isDestroying
      }
    case GO_TO_FORM:
      return {
        ...state,
        reminder: payload.reminder,
        mode: payload.mode,
        view: VIEWS.FORM,
        cameFrom: state.view
      }
    case GO_TO_DESTROY:
      return {
        ...state,
        reminder: payload.reminder,
        view: VIEWS.DESTROY,
        cameFrom: state.view
      }
    case GO_TO_ERROR:
      return {
        ...state,
        message: payload.message,
        view: VIEWS.ERROR,
        cameFrom: state.view
      }
    case REMINDER_CREATED:
      return {
        ...state,
        reminders: payload.reminders,
        view: VIEWS.INDEX,
        cameFrom: state.view
      }
    case REMINDER_UPDATED:
      return {
        ...state,
        reminders: payload.reminders,
        view: VIEWS.INDEX,
        cameFrom: state.view
      }
    case REMINDER_DELETED:
      return {
        ...state,
        reminders: payload.reminders,
        view: VIEWS.INDEX,
        cameFrom: state.view
      }
    default:
      return { ...state }
  }
}

export const propsToState = (props) => ({
  ...props,
  isLoading: true,
  view: VIEWS.INDEX,
  cameFrom: VIEWS.INDEX
})
